<template>
  <modal
    :title="
      setModel != null ? 'Update Customer Provider' : 'Add Customer Provider'
    "
    size="lg"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="providers == null || hotels == null || !load"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row align-items-start"
        ref="form"
        v-if="providers != null && hotels != null && load"
      >
        <div class="col-md-4">
          <selectBox
            :title="'ProviderId'"
            v-model.number="model.ProviderId"
            :errors="errors"
            :rules="{ required: true }"
            :buttons="true"
            @keydown.enter="save"
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara"
                class="form-control small"
                v-model="searchProviders"
              />
            </template>
            <template #input>
              <template
                v-for="item in $orderByArray(providers, 'Name', false, false)"
              >
                <option
                  :value="item.Id"
                  :key="item.Id"
                  v-if="
                    item.Name.toUpperCase().indexOf(
                      searchProviders.toUpperCase()
                    ) > -1
                  "
                  >{{ item.Name }}</option
                >
              </template>
            </template>
            <template #buttons>
              <button
                type="button"
                @click="addProviderOpen = true"
                class="btn waves-effect waves-light btn-success"
              >
                <i class="fas fa-plus"></i>
              </button>
            </template>
          </selectBox>
        </div>
        <div class="col-md-4">
          <selectBox
            :title="'Hotels'"
            v-model="model.Hotels"
            :errors="errors"
            multiple
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara..."
                class="form-control small"
                v-model.number="searchHotels"
              />
            </template>
            <template #inputCustom>
              <template
                v-for="item in $orderByArray(hotels, 'Name', false, false)"
              >
                <li
                  class="myCheckBox"
                  :key="item.Id"
                  v-if="
                    item.Name.toLowerCase().indexOf(
                      searchHotels.toLowerCase()
                    ) > -1
                  "
                >
                  <input
                    type="checkbox"
                    class="filled-in chk-col-teal"
                    :checked="model.Hotels.indexOf(item.Id) > -1"
                  />
                  <label
                    @click="
                      model.Hotels.indexOf(item.Id) > -1
                        ? (model.Hotels = model.Hotels.filter(
                            (x) => x != item.Id
                          ))
                        : model.Hotels.push(item.Id);
                      $refs.form.validateField('Oteliniz');
                    "
                  >
                    {{ item.Name }}
                  </label>
                </li>
                <!-- <option :value="item.Id" :key="item.v" v-if="item.Name.toLowerCase().indexOf(searchMyHotel.toLowerCase())>-1">{{item.Name}}</option> -->
              </template>
            </template>
          </selectBox>
        </div>
        <div class="col-md-4">
          <selectBox
            :title="'Rez Type'"
            v-model="model.Hotels"
            :errors="errors"
            multiple
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara..."
                class="form-control small"
                v-model.number="searchRezType"
              />
            </template>
            <template #inputCustom>
              <li class="myCheckBox">
                <input
                  type="checkbox"
                  id="chckNewProvider"
                  class="filled-in chk-col-teal"
                  v-model="model.New"
                />
                <label for="chckNewProvider">
                  New
                </label>
              </li>
              <li class="myCheckBox">
                <input
                  type="checkbox"
                  id="chckChangedProvider"
                  class="filled-in chk-col-teal"
                  v-model="model.Changed"
                />
                <label for="chckChangedProvider">
                  Changed
                </label>
              </li>
              <li class="myCheckBox">
                <input
                  type="checkbox"
                  id="chckCancelledProvider"
                  class="filled-in chk-col-teal"
                  v-model="model.Cancelled"
                />
                <label for="chckCancelledProvider">
                  Cancelled
                </label>
              </li>
              <li class="myCheckBox">
                <input
                  type="checkbox"
                  id="chckBookedProvider"
                  class="filled-in chk-col-teal"
                  v-model="model.Booked"
                />
                <label for="chckBookedProvider">
                  Booked
                </label>
              </li>
            </template>
          </selectBox>
        </div>
        <div class="col-md-12">
          <formGroup
            :title="'Username'"
            v-model="model.Username"
            :errors="errors"
            :rules="{
              required:
                model.ProviderId == null ||
                !providers.filter((x) => x.Id == model.ProviderId)[0]
                  .IsMailProvider,
              max: 255,
            }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Password'"
            v-model="model.Password"
            :errors="errors"
            :rules="{
              required:
                model.ProviderId == null ||
                !providers.filter((x) => x.Id == model.ProviderId)[0]
                  .IsMailProvider,
              max: 50,
            }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="parameterHelper('Parameter').name"
            v-model="model.Parameter"
            :errors="errors"
            :rules="{ max: 50,required: parameterHelper('Parameter').required }"
            @keydown.enter="save"
            :buttons="parameterHelper('Parameter').button || parameterHelper('Parameter').info"
          >
            <template v-if="parameterHelper('Parameter').button || parameterHelper('Parameter').info" #buttons>
              <button
                v-if="parameterHelper('Parameter').button"
                type="button"
                @click="model['Parameter'] = parameterHelper('Parameter').value"
                class="btn waves-effect waves-light btn-success"
                :title="parameterHelper('Parameter').description"
              >
                <i class="fa fa-magic"></i>
              </button>
              <button
                v-if="parameterHelper('Parameter').info"
                type="button"
                class="btn waves-effect waves-light btn-info"
                :title="parameterHelper('Parameter').description"
                @click="$swal({
                icon: 'info',
                title: 'Bilgi',
                html:parameterHelper('Parameter').description,
                confirmButtonText: 'Okey',
              })"
              >
                <i class="fa fa-info"></i>
              </button>
            </template>
          </formGroup>
          
          <formGroup
            :title="'Interval'"
            v-model.number="model.Interval"
            :errors="errors"
            @keydown.enter="save"
          >
          </formGroup>
        </div>
        <!--<div
          class="col-md-12"
          v-if="
            providers.filter((x) => {
              return x.Id == model.ProviderId;
            }).length > 0 &&
              providers.filter((x) => {
                return x.Id == model.ProviderId;
              })[0].IsMailProvider
          "
        >
          <formGroup
            :title="'Sender'"
            v-model="model.Sender"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'SenderType'"
            v-model="model.SenderType"
            :errors="errors"
            :rules="{ required: true }"
            as="select"
            @keydown.enter="save"
          >
            <template #input>
              <option value="from">From</option>
              <option value="to">To</option>
            </template>
          </formGroup>
        </div>-->
        <div class="col-12">
          <formGroup
            :title="'AgeCalculateModel'"
            as="select"
            v-model.number="model.AgeCalculateModel"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="1">Giriş tarihine göre yaş hesaplansın</option>
              <option :value="2"
                >Rezervasyon tarihine göre yaş hesaplansın</option
              >
            </template>
          </formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'VoucherType'"
            as="select"
            v-model.number="model.VoucherType"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="1">Full Voucher</option>
              <option :value="2">Operatör Voucher</option>
              <option :value="3">Client Voucher</option>
            </template>
          </formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'VoucherModel'"
            v-model.number="model.VoucherModel"
            :errors="errors"
            @keydown.enter="save"
          >
          </formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'NameUpperType'"
            as="select"
            v-model.number="model.NameUpperType"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="1">Olduğu gibi kalsın</option>
              <option :value="2">Hepsi büyük harf olsun</option>
              <option :value="3">Sadece baş harfleri büyük olsun</option>
            </template>
          </formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'ReferenceNo'"
            as="select"
            v-model="model.ReferenceNo"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="null"></option>
              <option :value="'kno'">Kayıt Numarası</option>
              <option :value="'voucher'">Voucher</option>
              <option :value="'rezno'">Rezervasyon No</option>
              <option :value="'ddmmyyyy'"
                >Confirm Tarih(Örnek:15.02.2023)</option
              >
              <option :value="'ddmmyy'">Confirm Tarih(Örnek:15.02.23)</option>
            </template>
          </formGroup>
        </div>
        <div class="col-12">
               <formGroup
            :title="'Passport Type'"
            as="select"
            v-model="model.PassportNumberType"
            :errors="errors"
            >
            <!-- @keydown.enter="save" -->
            <template #input>
              <option :value="null"></option>
              <option :value="1">Sahte Pasaport Numaralarını Kaldır</option>
              <option :value="2">Bütün Pasaport Numaralarını Kaldır</option>
            </template>
          </formGroup>
        </div>
        <div class="col-4" v-for="key in ['P1', 'P2', 'P3']" :key="key">
          <formGroup
            :title="parameterHelper(key).name"
            v-model="model[key]"
            :errors="errors"
            :rules="{ max: 800, required: parameterHelper(key).required }"
            @keydown.enter="save"
            :buttons="parameterHelper(key).button || parameterHelper(key).info"
          >
            <template v-if="parameterHelper(key).button || parameterHelper(key).info" #buttons>
              <button
                v-if="parameterHelper(key).button"
                type="button"
                @click="model[key] = parameterHelper(key).value"
                class="btn waves-effect waves-light btn-success"
                :title="parameterHelper(key).description"
              >
                <i class="fa fa-magic"></i>
              </button>
              <button
                v-if="parameterHelper(key).info"
                type="button"
                class="btn waves-effect waves-light btn-info"
                :title="parameterHelper(key).description"
                @click="$swal({
                icon: 'info',
                title: 'Bilgi',
                html:parameterHelper(key).description,
                confirmButtonText: 'Okey',
              })"
              >
                <i class="fa fa-info"></i>
              </button>
            </template>
          </formGroup>
        </div>
        <div class="col-12">
          <div class="card m-b-10 p-10">
            <div
              class="card-header p-t-0 p-l-0 p-r-0"
              :class="model.StaticProxy ? ' p-b-5' : 'p-b-0'"
            >
              <formGroup
                :title="'StaticProxy'"
                :as="'checkbox'"
                v-model="model.StaticProxy"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>

            <div class="collapse show" v-if="model.StaticProxy">
              <div class="row" style="margin:0 -5px;">
                <div class="col-6 p-l-5 p-r-5">
                  <formGroup
                    :title="'ProxyIP'"
                    v-model="model.ProxyIP"
                    :errors="errors"
                    @keydown.enter="save"
                    :rules="{ required: true }"
                  >
                  </formGroup>
                </div>
                <div class="col-6 p-l-5 p-r-5">
                  <formGroup
                    :title="'ProxyPort'"
                    v-model="model.ProxyPort"
                    :errors="errors"
                    type="number"
                    @keydown.enter="save"
                  >
                  </formGroup>
                </div>
                <div class="col-6 p-l-5 p-r-5">
                  <formGroup
                    :title="'ProxyUsername'"
                    v-model="model.ProxyUsername"
                    :errors="errors"
                    @keydown.enter="save"
                  >
                  </formGroup>
                </div>
                <div class="col-6 p-l-5 p-r-5">
                  <formGroup
                    :title="'ProxyPassword'"
                    v-model="model.ProxyPassword"
                    :errors="errors"
                    @keydown.enter="save"
                  >
                  </formGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <formGroup
            :title="'EmailAuthAddress'"
            v-model="model.EmailAuthAddress"
            :errors="errors"
            @keydown.enter="save"
          >
          </formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'SMSAuthNumber'"
            v-model="model.SMSAuthNumber"
            :errors="errors"
            @keydown.enter="save"
          >
          </formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="
              'Market bilgisi olmayan rezervasyonlarda ilk misafir uyruğu Market olarak kullanılsın.'
            "
            as="checkbox"
            v-model="model.UseFirstCitizenshipToMarket"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Oda bilgisinin sonuna pax bilgisi eklensin.'"
            as="checkbox"
            v-model="model.RoomPax"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Ad soyad bilgisi yer değiştirsin.'"
            as="checkbox"
            v-model="model.ChangeNameSurname"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Türkçe karakter kullanılsın'"
            as="checkbox"
            v-model="model.TurkishChars"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Voucher büyük harf olsun'"
            as="checkbox"
            v-model="model.VoucherUpper"
            @keydown.enter="save"
          >
          </formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Satış tarihinde saat bilgisi yer alsın'"
            as="checkbox"
            v-model="model.SaleClock"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Sadece kesinleşmiş rezervasyonlar'"
            as="checkbox"
            v-model="model.OnlyBooked"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Market acenta adının sonuna eklensin mi?'"
            as="checkbox"
            v-model="model.MarketToAgencyName"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Otel kodlarını manuel tanımlansın mı?'"
            as="checkbox"
            v-model="model.InternalHotelCodes"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'PaximumAPI'"
            as="checkbox"
            v-model="model.PaximumAPI"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Ay ve yıl acenta adının sonuna eklensin'"
            as="checkbox"
            v-model="model.AddMonthYear"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Send Reservation Parameters'"
            as="checkbox"
            v-model="model.SendReservationParameters"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Stopped'"
            as="checkbox"
            v-model="model.Stopped"
            @keydown.enter="save"
          ></formGroup>
        </div>

        <div class="col-12">
          <formGroup
            :title="'Aktif'"
            as="checkbox"
            v-model="model.Active"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <div class="col">
        <Btn
          class="btn-sm btn-primary"
          @click="test"
          :disabled="processTest"
          :process="processTest"
          >Test Connection</Btn
        >
      </div>
      <div class="col-auto">
        <Btn
          class="btn-success btn-md"
          @click="save"
          :disabled="providers == null || process"
          :process="process"
          >{{
            setModel != null
              ? "Update Customer Provider"
              : "Add Customer Provider"
          }}</Btn
        >
      </div>
    </template>
  </modal>
  <addProvider
    v-if="addProviderOpen"
    @close="addProviderOpen = false"
    @add="providers.push({ Id: $event.Id, Name: $event.Name })"
  ></addProvider>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
// import multipleSelectBox from "@/components/formGroup/multipleSelectBox";
import addProvider from "@/views/kolayrez/providers/upsert";
export default {
  props: {
    setModel: Object,
    CustomerId: Number,
  },
  components: { selectBox, addProvider },
  data() {
    return {
      load: false,
      addProviderOpen: false,
      model: {
        Id: null,
        CustomerId: this.CustomerId,
        ProviderId: null,
        Username: null,
        Password: null,
        Parameter: null,
        Interval: null,
        Sender: null,
        SenderType: null,
        AgeCalculateModel: 1,
        UseFirstCitizenshipToMarket: true,
        P1: null,
        P2: null,
        P3: null,
        Active: true,
        ChangeNameSurname: false,
        OnlyBooked: false,
        VoucherType: 1,
        VoucherModel: null,
        NameUpperType: 2,
        ReferenceNo: null,
        VoucherUpper: true,
        TurkishChars: false,
        MarketToAgencyName: true,
        SaleClock: true,
        Hotels: [],
        New: true,
        Changed: true,
        Cancelled: true,
        RoomPax: false,
        Booked: true,
        InternalHotelCodes: false,
        PaximumAPI: false,
        AddMonthYear: false,
        SenderrType: null,
        SendReservationParameters: false,
        StaticProxy: false,
        ProxyIP: "185.95.1.66",
        ProxyPort: null,
        ProxyUsername: "resbox",
        ProxyPassword: "Sx4380Fck",
        EmailAuthAddress: null,
        SMSAuthNumber: null,
        Stopped:false,
        PassportNumberType:null
      },
      providers: null,
      searchProviders: "",
      process: false,
      processTest: false,
      hotels: null,
      searchHotels: "",
      parameterHelpers:{
        "1":{
          "P1":{
            required:false,
            description:"Rezervasyonun içine girip detaillerini alır ve touroperator'e erişir.",
            value:"detail",
            button:true
          }
        },
        "2":{
          "P1":{
            required:true,
            description:"Uçuş saatleri alabilmek için ekliyoruz",
            value:"flight",
            button:true
          }
        },
        "3":{
          "P1":{
            required:false,
            name:"P1 - A. Taramadan Çıkar",
            description:"Girilen Acente ID'si Sedna Info Network tarama listesinden çıkarılır.(örn, Anex, Pegast) yazım örneği: 2,15784",
            info:true
          }
        },
        "5":{
          "P1":{
            required:true,
            description:'Alınan misafir isimleri tarama sonrası yeniden sıralanır. Misafir isimlerinin sırlamasının değişmesi sonucu "ReservationCode" değiştiği için yapıldı',
            value:"ordercustomers",
            button:true
          },
          "P2":{
            required:false,
            description:"Sejour'daki Fatura Başlığını acente adına ekler",
            value:"invoiceheader",
            button:true
          },
          "P3":{
            required:true,
            description:'Aynı bilgiler ile gönderilen çoklu rezervasyonların farklı ReservationCode oluşturması için yapıldı. Birebir aynı bilgiler ile gönderilen odalarda sadece 1 oda panele yansıyorsa bu kodu kullanıyoruz.',
            value:"Sejlogid",
            button:true
          }
        },
        "7":{
          "Parameter":{
            required:false,
            description:'Bekleyen rezervasyon sayısı yüksek olan otellerde (Örneğin Jacaranda) rezervasyonları .csv formatında parse etmek için kullanıyoruz',
            value:"tui2",
            button:true
          },
          "P1":{
            required:false,
            description:'TUI odatipi kodu ekleniyor. örn. "DZ - Standart Room"',
            value:"roomdetail",
            button:true
          },
          "P2":{
            required:false,
            description:"Brand Code bilgisine bağlı market bilgisi ataması yapar. (tui2 ile beraber kullanılamaz)",
            value:"brandcode",
            button:true
          },
          "P3":{
            required:false,
            description:'Rezervasyonun tur operatör bilgisi rezervasyon detayına eklemek için kullanıyoruz.',
            value:"tourop",
            button:true
          }
        },
        "10":{
          "P1":{
            required:true,
            description:'Rezervasyonları listeden getirir',
            value:"withoutdetail",
            button:true
          },
          "P2":{
            required:true,
            description:"Aynı bilgiler ile gönderilen çoklu rezervasyonların farklı ReservationCode oluşturması için yapıldı. Birebir aynı bilgiler ile gönderilen odalarda sadece 1 oda panele yansıyorsa bu kodu kullanıyoruz.",
            value:"vouchertocode",
            button:true
          }
        },
        "13":{
          "Parameter":{
            required:true,
            description:'Login olabilmemiz için gereken otel kodunu yazıyoruz',
            value:"false",
            info:true
          }
        },
        "15":{
          "P1":{
            required:false,
            description:'Login olurken phantomjs kütüphanesini kullanıyor',
            value:"phantomjs",
            button:true
          },
          "P2":{
            required:true,
            description:"Uçuş saatleri alabilmek için ekliyoruz",
            value:"flighttime",
            button:true
          }
        },
        "17":{
          "P3":{
            required:false,
            description:'Taramada tarih filtresi kullanmaz',
            value:"all",
            button:true
          },
        },
        "19":{
          "Parameter":{
            required:true,
            description:'Taranacak otellerin acentedeki IDleri yazılır. örn(11,12,33)',
            info:true
          },
        },
        "28":{
          "P1":{
            required:false,
            description:'<b>noxml</b> => xml ile biten oda varsa alma.<br><br> <b>xmltoagency</b> => xml ile biten odaların acente adını güncelle  agency.Name += (XML)',
            info:true
          },
        },
        "31":{
          "P1":{
            required:false,
            description:'<b>defaultboard:</b> ile başlayan bir değer varsa onu Board olarak ekleyecek. Örnedeğin: <b>defaultboard:AI</b>',
            info:true
          },
        },
        "35":{
          "Parameter":{
            required:true,
            description:'Login olabilmemiz için gereken otel kodunu yazıyoruz.',
            info:true
          },
          "P1":{
            required:true,
            description:'Aynı bilgiler ile gönderilen çoklu rezervasyonların farklı ReservationCode oluşturması için yapıldı. Birebir aynı bilgiler ile gönderilen odalarda sadece 1 oda panele yansıyorsa bu kodu kullanıyoruz.',
            value:"splitroom",
            button:true
          },
        },
        "44":{
          "Parameter":{
            required:true,
            description:'Taranacak otellerin acentedeki IDleri yazılır. örn:<b>11,12,33</b>',
            info:true
          }
        },
        "47":{
          "Parameter":{
            required:false,
            description:'Bu parametre girilirse Nordik kanalını tarar',
            value:"NORTHERN",
            button:true
          },
          "P1":{
            required:false,
            description:'TUI odatipi kodu ekleniyor. örn. <b>DZ - Standart Room</b>',
            value:"roomdetail",
            button:true
          },
          "P2":{
            required:false,
            description:'<b>latecheckout</b>:Late Checkout tipinde rezervasyonları parse etmesi istenirse ekleniyor.<br><b>brandcode:</b> Brand Code bilgisine bağlı market bilgisi ataması yapar',
            info:true
          },
          "P3":{
            required:false,
            description:'Brand numarasını acente adına yazar',
            value:"marketcode",
            button:true
          }
        },
        "49":{
          "P1":{
            required:false,
            description:'Status durumu unprocessed olan rezervasyonları alır',
            value:"unprocessed",
            button:true
          },
          "P2":{
            required:false,
            description:'Login olurken phantomjs kütüphanesini kullanıyor',
            value:"phantomjs",
            button:true
          }
        },
        "50":{
          "Parameter":{
            required:true,
            description:'Otel adı girilir.',
            info:true
          },
          "P2":{
            required:false,
            description:"Tarama yapılırken Hotelrunner'daki last modified date'in kaç gün geriye dönük bakılacağını belirtir. Default -7'dir. Örnek yazım: -5",
            info:true
          },
          "P3":{
            required:false,
            description:" acente isminin sonuna VIRTUAL CARD eklenecektir. ",
            value:"notecctoagencyname",
            button:true
          }
        },
        "57":{
          "Parameter":{
            required:true,
            description:"Taranacak otellerin acentedeki ID'leri yazılır. örn:<b>11,12,33</b>",
            info:true
          },
          "P1":{
            required:true,
            name:"P1 - Username"
          },
          "P2":{
            required:true,
            name:"P2 - Password"
          },
          "P3":{
            required:true,
            name:"P3 - Otelkodu"
          }
        },
        "58":{
          "Parameter":{
            required:true,
            description:"Taranacak otellerin acentedeki ID'leri yazılır. örn:<b>11,12,33</b>",
            info:true
          },
          "P1":{
            required:true,
            description:"Aynı bilgiler ile gönderilen çoklu rezervasyonların farklı ReservationCode oluşturması için yapıldı. Birebir aynı bilgiler ile gönderilen odalarda sadece 1 oda panele yansıyorsa bu kodu kullanıyoruz.",
            value:"splitrooms",
            button:true
          }
        },
        "67":{
          "Parameter":{
            required:true,
            description:"Mail başlığında gelen acente adını yazınca o aceneteye ait mailler <b>işleme alınmaz</b>.",
            info:true
          },
        },
        "87":{
          "Parameter":{
            required:true,
            description:"Taranacak otellerin acentedeki ID'leri yazılır. örn:<b>11,12,33</b>",
            info:true
          }
        },
        "91":{
          "Parameter":{
            required:true,
            description:"Taranacak otellerin acentedeki ID'leri yazılır. örn:<b>11,12,33</b>",
            info:true
          }
        },
        "96":{
          "P2":{
            required:false,
            description:"Voucher numarasının ilk 4 hanesini gün ay olarak satış tarihine yazar. örn: 11023697324 => 11.02.2025",
            value:"saledate",
            button:true
          }
        },
        "98":{
          "Parameter":{
            required:true,
            description:"Taranacak otellerin acentedeki ID'leri yazılır. örn:<b>11,12,33</b>",
            info:true
          }
        },
      }
    };
  },
  created() {
    if (this.setModel != null) {
      this.$appAxiosAdmin
        .get(`KOLAYREZ/CustomerProviders/` + this.setModel.Id)
        .then((response) => {
          this.model = { ...response.data };
          this.load = true;
          // this.providers = response.data;
        });
    } else {
      this.load = true;
    }
    this.$appAxiosAdmin.get(`kolayrez/Providers`).then((response) => {
      this.providers = response.data;
    });
    this.$appAxiosAdmin
      .get(`CustomerHotels/` + this.CustomerId)
      .then((response) => {
        this.hotels = response.data;
      });
  },
  computed: {
    parameterHelper() {
      return (key) => ({
        required: false,
        name: key,
        value: null,
        description: null,
        button:false,
        ...(this.parameterHelpers?.[this.model.ProviderId]?.[key] || {}),
      });
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`KOLAYREZ/CustomerProviders`, {
              ...this.model,
              VoucherModel:
                this.model.VoucherModel == "" ? null : this.model.VoucherModel,
              ProxyUsername:
                this.model.ProxyUsername == ""
                  ? null
                  : this.model.ProxyUsername,
              ProxyPassword:
                this.model.ProxyPassword == ""
                  ? null
                  : this.model.ProxyPassword,
              EmailAuthAddress:
                this.model.EmailAuthAddress == ""
                  ? null
                  : this.model.EmailAuthAddress,
              SMSAuthNumber:
                this.model.SMSAuthNumber == ""
                  ? null
                  : this.model.SMSAuthNumber,
            })
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The customer provider has been successfully updated."
                    : "The customer provider has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != null) {
                this.$emit("update", {
                  ...response.data,
                  Name: this.providers.filter(
                    (x) => x.Id == this.model.ProviderId
                  )[0].Name,
                });
              } else {
                this.$emit("add", {
                  ...response.data,
                  Name: this.providers.filter(
                    (x) => x.Id == this.model.ProviderId
                  )[0].Name,
                });
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
    test() {
      this.processTest = true;
      this.$appAxiosKolayrez
        .post(`Helpers/Auth`, {
          ProviderId: this.model.ProviderId,
          Username: this.model.Username,
          Password: this.model.Password,
          Parameter: this.model.Parameter,
        })
        .then(() => {
          this.processTest = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully connected.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processTest = false;
          this.$isError(err);
        });
    },
  },
};
</script>

<style></style>
